import {
  SET_LOADING,
  SET_ERROR,
  SET_OK,
  SET_RESET,
  SET_USERNAME,
  USER_LOGGED_OUT,
  SET_ADD,
  SET_CLIENT_ID,
  SET_SERVER_NAME,
  SET_COPY,
  SET_MODAL_BRAND,
  SET_MENU_SELECT,
  SET_WARNING,
  SET_SELECTED_CLIENT,
} from '../types'

export const setLoading = (show) => ({
  type: SET_LOADING,
  show,
})

export const setError = (text) => async (dispatch) => {
  dispatch({
    type: SET_ERROR,
    text,
  })

  setTimeout(() => {
    dispatch({
      type: SET_ERROR,
      text: '',
    })
  }, 6000)
}

export const setWarning = (text) => async (dispatch) => {
  dispatch({
    type: SET_WARNING,
    text,
  })

  setTimeout(() => {
    dispatch({
      type: SET_WARNING,
      text: '',
    })
  }, 6000)
}

export const setOk = (value) => ({
  type: SET_OK,
  value,
})
export const setCopy = (value) => ({
  type: SET_COPY,
  value,
})

export const setReset = (show) => ({
  type: SET_RESET,
  show,
})

export const setUsername = (username) => ({
  type: SET_USERNAME,
  username,
})

export const setAdd = (url) => ({
  type: SET_ADD,
  url,
})

export const logout = () => {
  localStorage.removeItem('bearer')
  localStorage.removeItem('persist:authType')
  return {
    type: USER_LOGGED_OUT,
  }
}

export const server_name = (value) => ({
  type: SET_SERVER_NAME,
  value,
})

export const client_id = (clientid) => ({
  type: SET_CLIENT_ID,
  clientid,
})

export const selected_client = (selectedClient) => ({
  type: SET_SELECTED_CLIENT,
  selectedClient,
})

export const setModalBrand = (value) => ({
  type: SET_MODAL_BRAND,
  value,
})

export const setMenuItem = (value) => ({
  type: SET_MENU_SELECT,
  value,
})
